/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Media_Caption_SelectionInputs */

const en_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media and Caption Selection`)
};

const fr_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection du media et des sous-titres`)
};

const de_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien- und Bildunterschriftenauswahl`)
};

const it_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione di media e didascalie`)
};

const ru_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор медиафайлов и субтитров`)
};

const es_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de medios y subtítulos`)
};

const zh_cn2_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体和字幕选择`)
};

const ja_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアとキャプションの選択`)
};

const hi_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया और कैप्शन चयन`)
};

const pt_pt2_embed_captions_media_caption_selection = /** @type {(inputs: Embed_Captions_Media_Caption_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de mídia e legendas`)
};

/**
* | output |
* | --- |
* | "Media and Caption Selection" |
*
* @param {Embed_Captions_Media_Caption_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_media_caption_selection = /** @type {((inputs?: Embed_Captions_Media_Caption_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Media_Caption_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_media_caption_selection(inputs)
	if (locale === "de") return de_embed_captions_media_caption_selection(inputs)
	if (locale === "it") return it_embed_captions_media_caption_selection(inputs)
	if (locale === "ru") return ru_embed_captions_media_caption_selection(inputs)
	if (locale === "es") return es_embed_captions_media_caption_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_media_caption_selection(inputs)
	if (locale === "ja") return ja_embed_captions_media_caption_selection(inputs)
	if (locale === "hi") return hi_embed_captions_media_caption_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_media_caption_selection(inputs)
	return en_embed_captions_media_caption_selection(inputs)
});